export default {"src":"/_next/static/media/yahoo.72a753ee.svg","height":696,"width":2500,"blurWidth":0,"blurHeight":0};